import React from 'react';
import { useNavigate } from 'react-router-dom';

const LogoutPage = () => {
  const navigate = useNavigate();

  const handleSignBackIn = () => {
    navigate('/organizer/sign-in');
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-gray-900">
      <div className="max-w-md w-full text-center p-8 rounded-lg shadow-xl bg-gray-800">
        {/* Logo/Icon */}
        <div className="mb-6">
          <div className="mx-auto w-20 h-20 rounded-full flex items-center justify-center bg-amber-500">
            <svg 
              className="w-10 h-10 text-white" 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
            >
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={2} 
                d="M5 13l4 4L19 7" 
              />
            </svg>
          </div>
        </div>

        {/* Thank You Message */}
        <h1 className="text-3xl font-bold mb-4 text-amber-400">
          Thanks for using WHIPT!
        </h1>

        <p className="text-lg mb-8 text-gray-300">
          You've been successfully signed out. Your data is saved and will be waiting for you when you return.
        </p>

        {/* Sign Back In Button */}
        <button
          onClick={handleSignBackIn}
          className="w-full py-3 px-6 rounded-lg font-semibold text-white transition-all transform hover:scale-105 bg-amber-500 hover:bg-amber-600"
        >
          Sign Back In
        </button>

        {/* Secondary Actions */}
        <div className="mt-6 space-y-3">
          <button
            onClick={() => navigate('/')}
            className="text-sm underline text-gray-400 hover:text-gray-300"
          >
            Go to Home Page
          </button>
        </div>

        {/* Footer Message */}
        <div className="mt-8 pt-6 border-t border-gray-700 text-gray-500 text-sm">
          <p>See you soon! 👋</p>
        </div>
      </div>
    </div>
  );
};

export default LogoutPage;
